/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const queryPagination = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 13.5h6v-3H4v3zm8 0h3v-3h-3v3zm5-3v3h3v-3h-3z" />
	</SVG>
);

export default queryPagination;
